import Modal from "@/components/common/Modal";

interface PolicyModalProps {
  open: boolean;
  onClose: () => void;
}

const PolicyModal = ({ open, onClose }: PolicyModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="lg"
      bodyClassName="max-h-[70vh] space-y-6 overflow-y-auto pr-2"
      hideCloseButton
    >
      <h5 className="px-4 py-2 rounded-full bg-gradient-to-r from-[#1BD3CC] to-[#2A51D6] text-white font-bold text-sm w-fit mx-auto">
        プライバシーポリシー
      </h5>
      <span className="text-sm font-medium text-text-muted">2025年4月1日制定</span>
      <p className="text-sm leading-relaxed text-text-main">
        本プライバシーポリシーでは、BrightKids株式会社（以下、当社）が提供するアプリケーション「STUDICT」（以下、当サービス）をご利用いただくにあたり、お客様の個人情報をどのように取り扱うかを定めております。個人情報の重要性を認識し、その適正な収集、利用、保護をはかり、安全に管理するため、次のとおり運用します。
      </p>
      <ul className="space-y-6 text-left text-sm leading-relaxed text-text-main/80">
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">個人情報の〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">2.〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">3.〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">4.〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">個人情報の〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">2.〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">3.〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
        <li className="space-y-2">
          <h3 className="font-semibold text-primary">4.〇〇〇〇〇〇〇〇〇〇〇〇</h3>
          <p>
            〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇
          </p>
        </li>
      </ul>
    </Modal>
  );
};

export default PolicyModal;
